import { render, staticRenderFns } from "./VerticalNavMenuLink.vue?vue&type=template&id=b7b46220&scoped=true&"
import script from "./VerticalNavMenuLink.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuLink.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenuLink.vue?vue&type=style&index=0&id=b7b46220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b46220",
  null
  
)

export default component.exports